// checkout/utils/loadWhat3WordsScript.ts

/**
 * Appends What3Words JS components (ESM + nomodule) to the document head.
 * This is used on the checkout review step.
 */
export function loadWhat3WordsScript(): void {
	const esmSrc =
		'https://cdn.what3words.com/javascript-components@4.9.1/dist/what3words/what3words.esm.js';
	const nomoduleSrc =
		'https://cdn.what3words.com/javascript-components@4.9.1/dist/what3words/what3words.js';

	// ESM script
	const esmScript = document.createElement('script');
	esmScript.type = 'module';
	esmScript.async = true;
	esmScript.src = esmSrc;
	document.head.appendChild(esmScript);

	// Nomodule fallback
	const legacyScript = document.createElement('script');
	legacyScript.setAttribute('nomodule', '');
	legacyScript.async = true;
	legacyScript.src = nomoduleSrc;
	document.head.appendChild(legacyScript);

	// Keep focusables inside the delivery-notes row untabbable while hidden.
	const row = document.querySelector<HTMLElement>('.form__row--delivery-notes');
	if (!row) return;

	const isHidden = () =>
		row.classList.contains('form__row--hidden') ||
		row.getAttribute('aria-hidden') === 'true' ||
		(row as any).hidden === true;

	const sync = () => {
		const hidden = isHidden();
		row.querySelectorAll<HTMLElement>('a,button,input,select,textarea,[tabindex]').forEach(
			(el) => {
				if (hidden) {
					el.setAttribute('tabindex', '-1');
				} else if (el.getAttribute('tabindex') === '-1') {
					el.removeAttribute('tabindex'); // restore natural tab order
				}
			},
		);
	};

	// Initial pass + react to visibility/children changes (W3W injects dynamically).
	sync();
	new MutationObserver(() => sync()).observe(row, {
		attributes: true,
		attributeFilter: ['class', 'aria-hidden', 'hidden'],
		childList: true,
		subtree: true,
	});
}
